'use strict';

/**
 * Handles Razorpay payment dismissal and makes an AJAX request to process the cancellation.
 * @param {Object} data - The data object to be sent in the AJAX request.
 * @param {string} dismissalUrl - The URL to handle payment dismissal.
 * @param {string} razorpayredirecturl - The URL to redirect the user after handling the dismissal.
 */
function callDismissalHandler(data, dismissalUrl, razorpayredirecturl) {
    $.spinner().start();
    $.ajax({
        url: dismissalUrl,
        data: data,
        type: 'POST',
        success: function (datares) {
            $.spinner().stop();
            if (datares.error) {
                $('.error-message').show();
                $('.error-message-text').text(datares.errorMsg);
            }
            if (razorpayredirecturl) {
                window.location.href = razorpayredirecturl;
            }
        },
        error: function (error) {
            $.spinner().stop();
            $('.error-message').removeClass('d-none');
            $('.error-message').show(error);
        }
    });
}

module.exports = {
    callDismissalHandler: callDismissalHandler
};
